import axios from 'axios'
import store from '../store'
// import Compress from './compress'
// require('./compress')

export default {
  async getSignedRequest(file){

    let newFile = await this.tratamentoImagem(file);

    let urlsApi = store.state.api

    return axios.get(urlsApi+`s3/sign-s3?file-name=${newFile.name}&file-type=${newFile.type}`).then(async (res) => {
      if(res.status === 200) {
        return await this.uploadFile(newFile, res.data.signedRequest, res.data.url);
      }
    }).catch(err => {
      return { salva: false, erro: err}
    });
  },
  uploadFile(file, signedRequest, url){
    return new Promise ((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', signedRequest);
      xhr.onreadystatechange = () => {
        if(xhr.readyState === 4){
          if(xhr.status === 200){
            resolve({ salva: true, url });
          }
          else{
            reject({ salva: false, erro: 'Arquivo inválida.'});
          }
        }
      };
      xhr.send(file);
    })
  },
  tratamentoImagem (file) {
    return new Promise((resolve, reject) => {
      console.log('original file => ', file)
      let file2 = file,
        reader = new FileReader(),
        reader2 = new FileReader(),
        // canvas = document.getElementById('canvas'),
        canvas = document.createElement('canvas'),
        ctx = canvas.getContext('2d')

      if (file) {
        reader.readAsDataURL(file)
        reader2.readAsDataURL(file2)
      }

      reader.addEventListener("load", function () {

        let imageObj1 = new Image(),
          imageObj2 = new Image(),
          imageObj3 = new Image()

        imageObj1.src = reader.result;
        imageObj1.onload = function () {

          const ALTURA = 280,
            LARGURA = 512
          let blur = 6,
            recorte = 1.8

          canvas.width = LARGURA;
          canvas.height = ALTURA;

          ctx.filter = `blur(${blur}px)`
          ctx.drawImage(imageObj1, 0, 0, LARGURA, ALTURA)
          ctx.filter = 'blur(0px)'

          imageObj3.src = canvas.toDataURL('image/jpeg')

          imageObj2.src = reader2.result;
          imageObj2.onload = function () {

            let width = this.width,
              height = this.height;

            if (width > height) {
              if (width > LARGURA) {
                height *= LARGURA / width;
                width = LARGURA;
              }
            } else {
              if (height > ALTURA) {
                width *= ALTURA / height;
                height = ALTURA;
              }
            }

            // recortando bordas
            ctx.drawImage(imageObj3, blur * recorte, blur * recorte, LARGURA - (blur * recorte * 2), ALTURA - (blur * recorte * 2), 0, 0, LARGURA, ALTURA)
            // redimentionando e posicionando imagem no centro
            ctx.drawImage(imageObj2, (LARGURA / 2) - (width / 2), (ALTURA / 2) - (height / 2), width, height);

            let dataURI = canvas.toDataURL('image/jpeg');
            var binary = atob(dataURI.split(',')[1]);
            var array = [];
            for(var i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }
            let newBlob = new Blob([new Uint8Array(array)], {type: 'image/jpeg'});

            // comprimindo imagem
            new Compress().compress([newBlob], {
              size: 4, // the max size in MB, defaults to 2MB
              quality: 0.75, // the quality of the image, max is 1,
              maxWidth: LARGURA, // the max width of the output image, defaults to 1920px
              maxHeight: ALTURA, // the max height of the output image, defaults to 1920px
              resize: false, // defaults to true, set false if you do not want to resize the image width and height
            }).then((images) => {
              let dataURI = `${images[0].prefix}${images[0].data}`;
              var binary = atob(dataURI.split(',')[1]);
              var array = [];
              for(var i = 0; i < binary.length; i++) {
                  array.push(binary.charCodeAt(i));
              }
              let newBlob = new Blob([new Uint8Array(array)], {type: 'image/jpeg'});

              let newFile = new File([newBlob], file.name, {type: file.type});
              console.log('finished => ', newFile)
              // preview.src = newFile.src
              resolve(newFile)
            })
          }
        };

      }, false);
    })
  }
}


// WEBPACK FOOTER //
// ./src/services/s3.js